import { populateObjectUID } from "../utils/index.js";
export const EXTRA_01 = populateObjectUID({ name: ["360°", "camera-system"] });
export const EXTRA_02 = populateObjectUID({ name: ["Inflatable tender"] });
/*export const EXTRA_03 = populateObjectUID({
  name: ["Black-package"],
  description: ["cleats, pop-up showers,", "etc."],
});*/
export const EXTRA_04 = populateObjectUID({
    name: ["Contrast stitching"],
    description: ["for upholstery"],
});
export const EXTRA_05 = populateObjectUID({
    name: ["Carbon rainshower"],
    description: ["on deck"],
});
export const EXTRA_06 = populateObjectUID({
    name: ["OnDeck", "smart control"],
});
export const EXTRA_07 = populateObjectUID({ name: ["Radar", "Garmin XHD"] });
export const EXTRA_08 = populateObjectUID({
    name: ["A/C upgrade"],
    description: ["(35.000 BTU)"],
});
export const EXTRA_09 = populateObjectUID({
    name: ["FLIR Night", "Vision System"],
});
export const EXTRA_10 = populateObjectUID({ name: ["Antifouling"] });
export const EXTRA_11 = populateObjectUID({
    name: ["Complete", "bow to stern cover"],
});
export const EXTRA_12 = populateObjectUID({
    name: ["30 kWh Li-Ion battery pack"],
});
export const EXTRA_13 = populateObjectUID({
    name: ["Seakeeper 1", "Gyroscopic Stabilizer"],
    description: ["(not compatible with trailer)"],
});
export const EXTRA_14 = populateObjectUID({
    name: ["Joystick docking"],
    description: ["and cruise control"],
});
export const EXTRA_15 = populateObjectUID({
    name: ["Bow sunpad carbon fibre hard cover"],
});
export const EXTRA_16 = populateObjectUID({
    name: ["A/C in Cabin"],
    description: ["(12.000 BTU)"],
});
export const EXTRA_17 = populateObjectUID({
    name: ["T-Top + AFT bimini"],
    description: ["with carbon fibre poles"],
});
export const EXTRA_18 = populateObjectUID({
    name: ["A/C upgrade"],
    description: ["(16.000 BTU)"],
});
export const EXTRA_19 = populateObjectUID({
    name: ["4kW low-noise", "diesel generator"],
});
//export const EXTRA_20 = populateObjectUID({ name: ["Natural certified teak", "with black lines"] });
export const EXTRA_21 = populateObjectUID({
    name: ["High windscreen", "with closure lid"],
});
export const EXTRA_22 = populateObjectUID({ name: ["TV in Bedroom"] });
export const EXTRA_23 = populateObjectUID({
    name: ["JL Audio High End", "sound system"],
});
export const EXTRA_24 = populateObjectUID({
    name: ["JL Audio high end", "upgrade"],
});
export const EXTRA_25 = populateObjectUID({
    uid: "windscreen",
    name: ["Full windscreen", "incl. whiper"],
});
export const EXTRA_26 = populateObjectUID({
    uid: "bi-colour",
    name: ["Bi-Colour painting", "on hull"],
});
